import { render, staticRenderFns } from "./BellIcon.vue?vue&type=template&id=5a6a1684&"
import script from "./BellIcon.vue?vue&type=script&lang=ts&"
export * from "./BellIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports